/*
  Página de perfil do usuário
  Desc: Página de perfil do usuário, onde ele pode ver e editar seus dados
  a senha solicita apenas o usuário digitar a senha antiga e a nova uma vez


*/

import React, { useState, useEffect } from 'react';
import {Typography, Grid, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, Box } from '@mui/material';
import AuthBuildHeaderUserObject from '../../usecases/AuthBuildHeaderUserObject';
import APIManager from '../../connection/APIManager';
import BasicCard from '../basic/BasicCard';
import InfoCard from '../basic/InfoCard';
import CacheLoadCredentials from '../../usecases/CacheLoadCredentials';
import CacheStoreCredentials from '../../usecases/CacheStoreCredentials';

function ProfilePage() {
  const [userData, setUserData] = useState({
    cpf_cnpj: '',
    nome: '',
    email: '',
    telefone: '',
  });

  const [editField, setEditField] = useState('');
  const [editValue, setEditValue] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [pendingChanges, setPendingChanges] = useState({});



  useEffect(() => {
    const loadDados = async () => {
      try{
      const email  = await AuthBuildHeaderUserObject();
      
      if (!email) {
        return;
      }

      const headers = {
        ...email,
      }
      const response = await APIManager.send(`/usuarios`, 'GET', headers);
      const json = await response.json();
      setUserData(json[0]);

    } catch (error) {
      console.error('Erro ao carregar os dados do usuário', error)
    }
  }
    loadDados();
  }, []);

  //Função para editar os dados do usuário
  const handleEditClick = (field) => {
    setEditField(field);
    setEditValue(userData[field]);
    setIsDialogOpen(true);
    setPendingChanges({ ...pendingChanges, [field]: userData[field] });
  };
  
  //Função responsavel por fechar a caixa suspensa
  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  //Função para salvar as alterações
  const handleSaveClick = async () => {
    try {
      const headers = await AuthBuildHeaderUserObject().catch(() => null);
      if (!headers) return;

      const updatedUserData = {
        ...userData,
        [editField]: editValue,
      };

      await APIManager.send(`/usuarios`, 'PUT', headers, { obj: updatedUserData }, 201);
      setUserData(updatedUserData);

      const session = await CacheLoadCredentials();
      if (session) {
        await CacheStoreCredentials({
          ...session,
          nome: updatedUserData.nome ?? session.nome,
          email: updatedUserData.email ?? session.email,
          telefone: updatedUserData.telefone ?? session.telefone,
        });
      }

      setPendingChanges({});
      setIsDialogOpen(false);
    } catch (e) {
      console.error('Erro ao salvar os dados do usuário', e);
    }
  };
  
  //Função para cancelar as alterações
  const handleCancelClick = () => {
    setIsDialogOpen(false);
    setPendingChanges({}); 
  };


  const allowedFields = [
    'cpf_cnpj', 
    'nome',
    'email', 
    'telefone', 
  ];

  return (
    <div>
      <Box sx={{ width: '60%', margin: '0 auto' }}>
        <Typography variant="h4" gutterBottom>
          Meu Perfil
        </Typography>
        <Grid container spacing={3}>
          {allowedFields.map((field) => (
            <Grid item xs={12} key={field}>
              <InfoCard style={{height:130}}>
              <TextField
                fullWidth
                label={field === 'cpf_cnpj' ? 'CPF/CNPJ' : field}
                value={typeof userData[field] === 'object' ? JSON.stringify(userData[field]) : userData[field]}
                disabled
                InputLabelProps={{ shrink: true }}
              />
              {field !== 'cpf_cnpj' && (
                <Button
                  variant="outlined"
                  size="small"
                  style={{ marginTop: 16 }}
                  onClick={() => {
                      handleEditClick(field)
                    }}
                >
                  Editar
                </Button>
              )}
              </InfoCard>
            </Grid>
          ))}
        </Grid>
          
        <Dialog open={isDialogOpen} onClose={handleDialogClose}>
          <DialogTitle>Editar {editField}</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              label={editField === 'cpf' ? 'CPF' : editField}
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancelClick} color="secondary">
              Cancelar
            </Button>
            <Button onClick={handleSaveClick} color="primary">
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
}

export default ProfilePage;
